/* Variant display follows server-rendered Shopify prices and availability. */
(() => {
  function initialise(scope) {
    scope.querySelectorAll('[data-pocket-product]').forEach(root => {
      if (root.dataset.pocketInitialised) return;
      root.dataset.pocketInitialised = 'true';
      const select = root.querySelector('[data-pocket-variant]');
      if (!select) return;
      const price = root.querySelector('[data-pocket-price]');
      const button = root.querySelector('[data-pocket-add]');
      const badge = root.querySelector('[data-pocket-badge]');
      const interest = root.querySelector('[data-pocket-interest-copy]');
      function update() {
        const option = select.selectedOptions[0];
        if (!option || !button) return;
        const available = option.dataset.available === 'true';
        if (price) price.textContent = option.dataset.price;
        button.disabled = !available;
        button.textContent = available ? 'Add to cart' : 'Sold out';
        if (badge) badge.hidden = available;
        if (interest) interest.textContent = available
          ? 'Join the list for product news and updates.'
          : 'Currently sold out. Join the list for product news and availability updates.';
      }
      select.addEventListener('change', update);
      update();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(document), {once: true});
  } else {
    initialise(document);
  }
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
